import { Application } from "@hotwired/stimulus"

const application = Application.start()

// Import and register all controllers
import ActiveController from "./active_controller"
import BookingController from "./booking_controller"
import BookingRequestController from "./booking_request_controller"
import CancelJobController from "./cancel_job_controller"
import ConfirmJobController from "./confirm_job_controller"
import DrawerMenuController from "./drawer_menu_controller"
import FlatpickrController from "./flatpickr_controller"
import FormController from "./form_controller"
import HomeController from "./home_controller"
import InvoiceController from "./invoice_controller"
import InvokerController from "./invoker_controller"
import LoadingController from "./loading_controller"
import NannyAvailabilityController from "./nanny_availability_controller"
import PasswordController from "./password_controller"
import PlacesController from "./places_controller"
import QualificationsFilterController from "./qualifications_filter_controller"
import RadioSelectorController from "./radio_selector_controller"
import RatingController from "./rating_controller"
import ReferralsController from "./referrals_controller"
import SelectController from "./select_controller"
import StripeController from "./stripe_controller"
import SubmitOnChangeController from "./submit_on_change_controller"
import TabsController from "./tabs_controller"
import ToggleController from "./toggle_controller"
import TurboController from "./turbo_controller"
import TurboFormSubmitRedirectController from "./turbo_form_submit_redirect_controller"
import UiController from "./ui_controller"

application.register("active", ActiveController)
application.register("booking", BookingController)
application.register("booking-request", BookingRequestController)
application.register("cancel-job", CancelJobController)
application.register("confirm-job", ConfirmJobController)
application.register("drawer-menu", DrawerMenuController)
application.register("flatpickr", FlatpickrController)
application.register("form", FormController)
application.register("home", HomeController)
application.register("invoice", InvoiceController)
application.register("invoker", InvokerController)
application.register("loading", LoadingController)
application.register("nanny-availability", NannyAvailabilityController)
application.register("password", PasswordController)
application.register("places", PlacesController)
application.register("qualifications-filter", QualificationsFilterController)
application.register("radio-selector", RadioSelectorController)
application.register("rating", RatingController)
application.register("referrals", ReferralsController)
application.register("select", SelectController)
application.register("stripe", StripeController)
application.register("submit-on-change", SubmitOnChangeController)
application.register("tabs", TabsController)
application.register("toggle", ToggleController)
application.register("turbo", TurboController)
application.register("turbo-form-submit-redirect", TurboFormSubmitRedirectController)
application.register("ui", UiController)

export { application }
